import css from 'styled-jsx/css';

const styles = css.global`#page-emprestimo-garantia {
    display: none;
}

#page-emprestimo-garantia.show {
    display: block;
}

@media (min-width: 1280px) {
    .ctn-home-24 {
        padding-right: 0;
        padding-left: 0;
    }
  }`;

export default styles;